<template>
    <el-drawer
      :visible.sync="drawerVisible"
      :with-header="false"
      size="450px"
      direction="rtl"
      :before-close="handleClose">
      <div class="vessel-edit-drawer">
        <div class="drawer-header">
          <h3>编辑船舶信息</h3>
          <i class="el-icon-close" @click="handleClose"></i>
        </div>
        <div class="drawer-body">
          <el-form ref="vesselForm" :model="vesselForm" label-width="100px" size="small">
            <el-form-item label="中文名称" prop="cnName">
              <el-input v-model="vesselForm.cnName" placeholder="请输入中文名称"></el-input>
            </el-form-item>
            <el-form-item label="英文名称" prop="vesselName">
              <el-input v-model="vesselForm.vesselName" placeholder="请输入英文名称"></el-input>
            </el-form-item>
            <el-form-item label="MMSI" prop="mmsi">
              <el-input v-model="vesselForm.mmsi" disabled></el-input>
            </el-form-item>
            <el-form-item label="船舶类型" prop="vesselType">
              <el-select v-model="vesselForm.vesselType" placeholder="请选择船舶类型" style="width: 100%" filterable>
                <el-option
                  v-for="item in vesselTypeOptions"
                  :key="item.typeCode"
                  :label="item.typeName"
                  :value="item.typeCode">
                </el-option>
                <div v-if="vesselTypeOptions.length === 0" class="el-select-dropdown__empty">
                  正在加载船舶类型...
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="呼号" prop="callSign">
              <el-input v-model="vesselForm.callSign" placeholder="请输入呼号"></el-input>
            </el-form-item>
            <el-form-item label="IMO编号" prop="imo">
              <el-input v-model="vesselForm.imo" placeholder="请输入IMO编号"></el-input>
            </el-form-item>
            <el-form-item label="船旗国" prop="flag">
              <el-input v-model="vesselForm.flag" placeholder="请输入船旗国"></el-input>
            </el-form-item>
            <el-form-item label="长度(米)" prop="length">
              <el-input-number v-model="vesselForm.length" :min="0" :precision="2" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item label="宽度(米)" prop="width">
              <el-input-number v-model="vesselForm.width" :min="0" :precision="2" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item label="吃水(米)" prop="depth">
              <el-input-number v-model="vesselForm.depth" :min="0" :precision="2" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item label="载重量(吨)" prop="load">
              <el-input-number v-model="vesselForm.load" :min="0" :precision="2" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item label="总吨位" prop="grossTonnage">
              <el-input v-model="vesselForm.grossTonnage" placeholder="请输入总吨位"></el-input>
            </el-form-item>
            <el-form-item label="建造年份" prop="buildYear">
              <el-input v-model="vesselForm.buildYear" placeholder="请输入建造年份"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="vesselForm.contacts" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactNumber">
              <el-input v-model="vesselForm.contactNumber" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="备注信息" prop="remark">
              <el-input 
                type="textarea" 
                v-model="vesselForm.remark" 
                :rows="3"
                placeholder="请输入备注信息">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSave" :loading="saveLoading">保 存</el-button>
        </div>
      </div>
    </el-drawer>
  </template>
  
  <script>
  import { getAllVesselTypes, updateVessel, getVesselByMmsi,createVessel } from '@/api/vessel'
  import BridgeEventBus, { BRIDGE_EVENTS } from '@/utils/BridgeEventBus';
  
  export default {
    name: 'VesselEditDrawer',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      vessel: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        drawerVisible: false,
        vesselForm: {
          id: '',
          mmsi: '',
          vesselName: '',
          cnName: '',
          vesselType: '',
          callSign: '',
          imo: '',
          flag: '中国',
          length: '',
          width: '',
          depth: '',
          load: '',
          grossTonnage: '',
          buildYear: '',
          contacts: '',
          contactNumber: '',
          remark: ''
        },
        vesselTypeOptions: [],
        saveLoading: false
      }
    },
    watch: {
      visible(val) {
        this.drawerVisible = val
        if (val) {
          this.initForm()
          this.fetchVesselTypes()
        }
      },
      drawerVisible(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    },
    methods: {
      initForm() {
        // 使用深拷贝避免直接修改props
        if (this.vessel && this.vessel.userid) {
          // 获取完整的船舶信息
          this.fetchVesselDetail(this.vessel.userid)
        }
      },
      fetchVesselDetail(mmsi) {
        getVesselByMmsi(mmsi).then(response => {
          if (response.code === 200 && response.data) {
            // 用API返回的详细数据填充表单
            this.vesselForm = { ...response.data }
            // 如果没有id，可能是初次保存到数据库的船舶，只有AIS信息
            if (!this.vesselForm.id) {
              // 用当前船舶信息填充缺少的字段
              this.vesselForm = {
                ...this.vesselForm,
                mmsi: this.vessel.userid || mmsi,
                vesselName: this.vessel.shipname || this.vesselForm.vesselName,
                cnName: this.vessel.cnName || this.vesselForm.cnName
              }
            }
          } else {
            // 如果API没有返回数据，使用当前船舶信息
            this.vesselForm = {
              mmsi: this.vessel.userid || mmsi,
              vesselName: this.vessel.shipname || '',
              cnName: this.vessel.cnName || '',
              vesselType: this.vessel.shipType || '',
              length: this.vessel.length || '',
              width: this.vessel.width || '',
              depth: this.vessel.depth || '',
              load: this.vessel.load || ''
            }
          }
        }).catch(() => {
          // 发生错误时仍然使用当前船舶信息
          this.vesselForm = {
            mmsi: this.vessel.userid || '',
            vesselName: this.vessel.shipname || '',
            cnName: this.vessel.cnName || '',
            vesselType: this.vessel.shipType || '',
            length: this.vessel.length || '',
            width: this.vessel.width || '',
            depth: this.vessel.depth || '',
            load: this.vessel.load || ''
          }
        })
      },
      fetchVesselTypes() {
        getAllVesselTypes().then(response => {
          if (response.code === 200) {
            this.vesselTypeOptions = response.data || []
          }
        })
      },
      handleClose() {
        this.drawerVisible = false
        this.$emit('update:visible', false)
        this.$emit('close')
      },
      handleSave() {
        this.$refs.vesselForm.validate(valid => {
          if (!valid) return
          
          this.saveLoading = true
          const saveData = { ...this.vesselForm }
          // console.warn('【调试】saveData',saveData)
          
          // 判断是更新还是创建
          if (saveData.id) {
            updateVessel(saveData.id, saveData)
              .then(this.handleSaveSuccess)
              .catch(this.handleSaveError)
              .finally(() => {
                this.saveLoading = false
              })
          } else {
            // // 调用创建船舶API - 这里省略创建逻辑，实际项目中可以添加
            // this.$message.warning('新建船舶功能尚未实现，请联系管理员')
            createVessel(saveData)
              .then(this.handleSaveSuccess)
              .catch(this.handleSaveError)
              .finally(() => {
                this.saveLoading = false
              })
            
            this.saveLoading = false
           
            BridgeEventBus.$emit(BRIDGE_EVENTS.SHIP_UPDATED, saveData)
          }
        })
      },
      handleSaveSuccess(response) {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.$emit('saved', response.data)
          this.handleClose()
        } else {
          this.$message.error(response.message || '保存失败')
        }
      },
      handleSaveError(error) {
        console.error('保存船舶信息失败', error)
        this.$message.error('保存失败：' + (error.message || '未知错误'))
      }
    }
  }
  </script>
  
  <style scoped>
  .vessel-edit-drawer {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }
  
  .drawer-header {
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
  }
  
  .drawer-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
  }
  
  .drawer-header i {
    font-size: 20px;
    cursor: pointer;
    color: #909399;
  }
  
  .drawer-header i:hover {
    color: #409EFF;
  }
  
  .drawer-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 0;
  }
  
  .drawer-footer {
    padding: 15px 0;
    text-align: right;
    border-top: 1px solid #e6e6e6;
  }
  </style>